const errorCodes: { [key: string]: string } = {
  "10":
    "エラーコード:10\n入力されていない項目があります。全項目を入力してから再度お試しください。",
  OCC_10:
    "入力されていない項目があります。全項目を入力してから再度お試しください。",
  "11":
    "エラーコード:11\n連携コードに誤りがあるか、入力されていない項目があります。連携コードをお確かめの上、全項目を入力してから再度お試しください。",
  "20":
    "エラーコード:20\n連携コードに誤りがあります。お確かめの上、不明の場合はヒューマネージ社にお問い合わせください。",
  "21":
    "エラーコード:21\n企業IDをお確かめの上、ヒューマネージ社へお問い合わせください。",
  "22":
    "エラーコード:22\n連携コード・連携卒年度・連携種別のいずれかに誤りがあります。不明の場合はヒューマネージ社にお問い合わせください。また、イベントページの種別（説明会・セミナー/インターン/本選考）とi-web種別は必ずしも一致する必要はございません。",
  OCC_22:
    "連携コード・連携卒年度・連携種別のいずれかに誤りがあります。不明の場合はワンキャリア社にお問い合わせください。また、イベントページの種別（説明会・セミナー/インターン/本選考）とi-web種別は必ずしも一致する必要はございません。",
  "80":
    "エラーコード:80\ni-webシステムがメンテナンス中のため、時間を空けて再度お試しください。不明の場合はヒューマネージ社にお問い合わせください。",
  "90":
    "エラーコード:90\ni-webシステムへの接続がタイムアウトし、連携できませんでした。詳細についてはヒューマネージ社へお問い合わせください。",
  "96":
    "エラーコード:96\ni-webシステムに障害が発生し、連携できませんでした。詳細についてはヒューマネージ社へお問い合わせください。",
  "99":
    "エラーコード:99\ni-webシステムに障害が発生し、連携できませんでした。詳細についてはヒューマネージ社へお問い合わせください。",
  OCC_99:
    "i-webシステムに障害が発生し、連携できませんでした。詳細についてはワンキャリア社にお問い合わせください。"
};

export function getErrorMessageFromIwebErrorCode(error_code: string) {
  // 実装漏れがあった場合undefinedを返さないよう、対応するエラー文言が取得できなかった場合はこの文言を返却する
  const unknownErrorMessage =
    "予期せぬコードです。詳細についてはワンキャリア社にお問い合わせください。";

  return errorCodes[error_code] ?? unknownErrorMessage;
}
